import { render, staticRenderFns } from "./reason-delete.vue?vue&type=template&id=49e8bdc5"
import script from "./reason-delete.vue?vue&type=script&lang=js"
export * from "./reason-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports